// extracted by mini-css-extract-plugin
export var banner = "_e8-0";
export var closeButton = "_e8-2";
export var greenCheckmark = "_e8-3";
export var hereLink = "_e8-4";
export var titleIcon = "_e8-1";